module.exports = __webpack_public_path__ + "media/src/images/styleguide/Rectangle2-7f6ef7af8d31b2789c33ad86eed90b31.png";